import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ABCallButtonContainer, FavoriteButtonContainer, MoreFlatsButton } from './parts';
import { trackClickNewbuildingDecoration } from './tracking';
import { FullscreenPopup } from '../../components/Advantages/components/FullscreenPopup';
import { ABContent } from '../../components/Advantages/components/FullscreenPopup/components/ABContent';
import { ABHeader } from '../../components/Advantages/components/FullscreenPopup/components/ABHeader';
import { NewbuildingDecorationItems } from '../../components/NewbuildingDecorations/parts/NewbuildingDecorationItems/NewbuildingDecorationItems';
import { getNewbuildingDecorations, getNewbuildingName, getOfferId } from '../../selectors/newObject';

export const DecorationItemsRedesign = () => {
  const decorations = useSelector(getNewbuildingDecorations);
  const name = useSelector(getNewbuildingName);
  const offerId = useSelector(getOfferId);

  const [isOpened, setOpenedState] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setIndex(i);
      setOpenedState(true);
      trackClickNewbuildingDecoration({ offerId, label: 'jk', type: decorations[i].type });
    },
    [setOpenedState, setIndex],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (decorations.length === 0) {
    return null;
  }

  const decoration = decorations[index];

  return (
    <NewbuildingDecorationItems
      items={decorations}
      onItemClick={onItemClick}
      popup={
        <FullscreenPopup
          isOpened={isOpened}
          header={
            <ABHeader
              onClose={onClose}
              title={<UIText1>ЖК «{name}»</UIText1>}
              callButton={<ABCallButtonContainer />}
              favoriteButton={<FavoriteButtonContainer />}
            />
          }
          onClose={onClose}
          content={
            <ABContent
              title={decoration.title}
              description={decoration.description}
              images={decoration.images}
              moreFlatsButton={decoration.searchUrl ? <MoreFlatsButton href={decoration.searchUrl} /> : null}
            />
          }
        />
      }
    />
  );
};
